<mat-accordion class="diagnosis-section">
  <mat-expansion-panel class="diagnosis-panel">
    <mat-expansion-panel-header class="diagnosis-panel__header">
      <mat-panel-title class="diagnosis-panel__title">
        @if (diagnose(); as summary) {
          <span class="diagnosis-panel__badge">{{ summary.code }}</span>
        }
        <span class="diagnosis-panel__label" [matTooltip]="diagnosisName()" matTooltipClass="card-tooltip">
          {{ diagnosisName() }}
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    @if (kenmerken().length > 0) {
      @if (labelsResolved()) {
        @for (groep of groepen(); track groep.type) {
          <div class="diagnosis-panel__group">
            <span class="diagnosis-panel__group-title">
              {{ 'epd.functions.careplan-nnn.knowledge-base.' + groep.titleKey | translate | capitalize }}
            </span>
            <ul class="diagnosis-panel__kenmerken">
              @for (item of groep.items; track item.key) {
                <li class="diagnosis-panel__kenmerk" [class.diagnosis-panel__kenmerk--inactive]="item.inactive">
                  <span class="diagnosis-panel__kenmerk-name">{{ item.label }}</span>
                  @if (item.hint) {
                    <span class="diagnosis-panel__kenmerk-hint">{{ item.hint }}</span>
                  }
                  @if (item.inactive) {
                    <span class="diagnosis-panel__kenmerk-inactive">
                      {{ 'epd.functions.careplan-nnn.diagnosis-section.inactive' | translate }}
                    </span>
                  }
                </li>
              }
            </ul>
          </div>
        }
      } @else {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    } @else {
      <p class="diagnosis-panel__no-kenmerken">
        {{ 'epd.functions.careplan-nnn.diagnosis-section.no-kenmerken' | translate | capitalize }}
      </p>
    }
    <app-nnn-notes-cell
      labelKey="epd.functions.careplan-nnn.diagnosis-section.notes"
      [value]="notes()"
      [disabled]="!editable()"
      [saveState]="saveState()"
      [showCounter]="showNotesCounter()"
      (valueInput)="notesInput.emit($event)"
      (save)="notesSave.emit()"></app-nnn-notes-cell>
    @if (editable()) {
      <div class="diagnosis-panel__actions">
        <button
          mat-icon-button
          type="button"
          class="diagnosis-panel__action diagnosis-panel__action--info"
          (click)="openInfo()"
          matTooltip="{{ 'epd.functions.careplan-nnn.diagnosis-section.info-button' | translate | capitalize }}"
          matTooltipClass="card-tooltip">
          <mat-icon>info_outline</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          class="diagnosis-panel__action diagnosis-panel__action--edit"
          [disabled]="!diagnose()"
          (click)="openEdit()"
          matTooltip="{{ 'epd.functions.careplan-nnn.diagnosis-section.edit-button' | translate | capitalize }}"
          matTooltipClass="card-tooltip">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    }
  </mat-expansion-panel>
</mat-accordion>
